<mat-toolbar color="primary" class="mat-toolbar">

    <ng-container *ngIf="!sidenav.opened">
        <div class="menu-outside">
          <button mat-icon-button class="menu-btn" (click)="sidenav.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
        </div>
    </ng-container>

    <button mat-button routerLink="menu" class="btn-home" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
        <img src="../../../assets/images/logo/sennebogen_diagnostics_logo_white.png" class="logo" alt="Sennebogen Logo" />
    </button>

    <div class="small_spacer" *ngIf="this.connected"></div>
    <p class="number">{{machinenumber}}</p>

    <ng-container *ngIf="env.staging">
        <span class="spacer"></span>
        <a class="staging">STAGING</a>
    </ng-container>
    <span class="spacer"></span>
    
    <!--<ng-container *ngIf="this.connected">
        <mat-chip [disabled]="!this.connected"
        [ngClass]="{
            'green-chip': this.apiGwConnection.gatewayConnected && this.apiGwConnection.machineStatus == 'ONLINE',
            'red-chip': this.apiGwConnection.gatewayConnected == false || this.apiGwConnection.machineStatus == 'OFFLINE'
        }"
    >
        {{ this.apiGwConnection.gatewayConnected && this.apiGwConnection.machineStatus == 'ONLINE' ? ("TOOLBAR.STATUS_OK" | translate) : ("TOOLBAR.STATUS_NOT" | translate) }}</mat-chip
    >
    </ng-container>-->
    <ng-container *ngIf="this.connected">
        <mat-chip [disabled]="!this.connected"
        [ngClass]="{
            'green-chip': this.apiGwConnection.gatewayConnected,
            'red-chip': this.apiGwConnection.gatewayConnected == false
        }"
    >
        {{ this.apiGwConnection.gatewayConnected ? ("TOOLBAR.GW_OK" | translate) : ("TOOLBAR.GW_NOT" | translate) }}</mat-chip
    >
    </ng-container>

    <ng-container *ngIf="this.connected">
        <button mat-icon-button (click)="switchMachine()" class="icon" #tooltip="matTooltip" [matTooltip]="('TOOLBAR.DISCONNECT' | translate)" matTooltipPosition="below">
            <mat-icon>link_off</mat-icon>
        </button>
    </ng-container>

    <!--<ng-container *ngIf="this.connected && this.roleService.isRole('Admin')">
        <mat-chip [disabled]="!this.connected"
        [ngClass]="{
            'green-chip': this.apiGwConnection.machineStatus == 'ONLINE',
            'red-chip': this.apiGwConnection.machineStatus == 'OFFLINE'
        }"
    >
        {{ this.apiGwConnection.machineStatus == 'ONLINE' ? ("TOOLBAR.M_STATUS_OK" | translate) : ("TOOLBAR.M_STATUS_NOT" | translate) }}</mat-chip
    >
    </ng-container>-->

    <div *ngIf="this.roleService.isRole('Basic')">
        <button mat-icon-button (click)="quickstart()" class="icon" #tooltip="matTooltip" [matTooltip]="('TOOLBAR.QUICKSTART_TIP' | translate)" matTooltipPosition="below">
            <mat-icon svgIcon="question"></mat-icon>
        </button>
    </div>

    <div *ngIf="this.roleService.isRole('Basic')">
        <button mat-icon-button (click)="reportError()" class="icon" #tooltip="matTooltip" [matTooltip]="('TOOLBAR.FEEDBACK_TIP' | translate)" matTooltipPosition="below">
            <mat-icon svgIcon="feedback"></mat-icon>
        </button>
    </div>

    <select #language class="language" [value]="currentLanguage" (change)="onSelected(language.value)">
        <option value="de">DE</option>
        <option value="en">EN</option>
    </select>

    <a class="username">{{this.user.toUpperCase()}}</a>

    <ng-container *ngIf="!this.roleService.isRole('Basic') && !this.roleService.isRole('Admin')">
        <button mat-icon-button class="icon" [matMenuTriggerFor]="menuDenied">
            <mat-icon svgIcon="account"></mat-icon>
        </button>

        <mat-menu #menuDenied="matMenu">
            <!--<button mat-menu-item routerLink="about">
                <mat-icon>info_outline</mat-icon>
                <span>{{"ABOUT.HEADER" | translate}}</span>
            </button>-->
            <button mat-menu-item (click)="logOut()">
                <mat-icon>power_settings_new</mat-icon>
                <span>{{"TOOLBAR.LOGOUT" | translate}}</span>
            </button>
        </mat-menu>
    </ng-container>


    <div *ngIf="this.roleService.isRole('Basic')">
        <button mat-icon-button [matMenuTriggerFor]="menu" class="icon">
            <mat-icon svgIcon="account"></mat-icon>
        </button>
    </div>

    <mat-menu #menu="matMenu">
        
        <button mat-menu-item routerLink="connectionManager" class="admin" *ngIf="this.roleService.isRole('Admin')">
            <mat-icon>link</mat-icon>
            <span>{{"TOOLBAR.CONNECTIONS.MANAGER" | translate}}</span>
        </button>
        <mat-divider style="margin: 5px 0 5px 0" *ngIf="this.roleService.isRole('Admin')"></mat-divider>
        
        <button mat-menu-item routerLink="about">
            <mat-icon>info_outline</mat-icon>
            <span>{{"ABOUT.HEADER" | translate}}</span>
        </button>
        <button mat-menu-item (click)="logOut()">
            <mat-icon>power_settings_new</mat-icon>
            <span>{{"TOOLBAR.LOGOUT" | translate}}</span>
        </button>
    </mat-menu>
    
</mat-toolbar>
